import { render, staticRenderFns } from "./ABIcon.vue?vue&type=template&id=fc7ef4d0&scoped=true"
import script from "./ABIcon.vue?vue&type=script&lang=js"
export * from "./ABIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7ef4d0",
  null
  
)

export default component.exports